import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {ICharacterTrait} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchCharacterTraitsThunk: any = createAsyncThunk<ICharacterTrait[]>(
  `${prefix} fetchCharacterTraits`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getCharacterTraits();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch character traits. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
